import { Injectable } from "@angular/core";
import { Validators, FormControl, FormGroup } from "@angular/forms";

export interface IAttributeControlService<T>{
    createFormControl(name: string, required: boolean, value: T): FormControl;   
    addFormControl(name: string, required: boolean, value: T, formGroup: FormGroup): void;
    removeControl(name: string, formGroup: FormGroup): void;
    getValue(name: string, formGroup: FormGroup): T
}

@Injectable()
export class AttributeControlService<T> implements IAttributeControlService<T>{
    constructor(){}    

    createFormControl(name: string, required: boolean, value: T): FormControl{
        let control: FormControl = required ? new FormControl(value, Validators.required) : new FormControl(value); 
        return control;
    }
  
    addFormControl(name: string, required: boolean, value: T, formGroup: FormGroup): void{                
        let control: FormControl = required ? new FormControl(value, Validators.required) : new FormControl(value); 
        formGroup.addControl(name, control);
    }    

    removeControl(name: string, formGroup: FormGroup): void{
        formGroup.removeControl(name);
    }

    getValue(name: string, formGroup: FormGroup): T{
       return  formGroup.value[name];
    }
}